import _ from 'underscore';

export const Months = [
  'jan', 'feb', 'mar', 'apr',
  'may', 'jun', 'jul', 'aug',
  'sept', 'oct', 'nov', 'dec',
];

export const MonthsRowCount = 4;

export const MonthsGroup = _.chain(Months)
  .groupBy((m, index) => (Math.floor(index / MonthsRowCount)))
  .values()
  .value();
